import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';

import * as fromApp from '@store';
import { AppConfigService } from '@core/api/app-config.service';

@Component({
  selector: 'fc-app-footer',
  templateUrl: './app-footer.component.html',
  styleUrls: ['./app-footer.component.scss'],
  standalone: false
})
export class AppFooterComponent implements OnInit {
  destroyRef = inject(DestroyRef);
  helpPhone = '';
  helpEmail = '';

  constructor(
    readonly store: Store<fromApp.AppState>,
    readonly appConfigService: AppConfigService,
    readonly router: Router
  ) {
  }

  ngOnInit(): void {
    this.helpPhone = this.appConfigService.getValue('fc_help_phone');
    this.helpEmail = this.appConfigService.getValue('fc_help_email');
  }

  goToFC() {
    window.open('https://www.landyield.com/', '_blank', 'noopener');
  }

  navigate(url: string) {
    window.open(url, '_blank', 'noopener');
  }
}
